import type { CancelToken } from 'axios'
import { AxiosAction } from 'redux-axios-middleware'

import { OptionItems } from 'models/Modifier'
import { PaginationT } from 'models/Pagination'
import { ResolvedAxiosAction } from 'utilities/types'

export const GET_MODIFIERS = 'modifier/GET_MODIFIERS'
export const GET_MODIFIERS_SUCCESS = 'modifier/GET_MODIFIERS_SUCCESS'
export const GET_MODIFIERS_FAIL = 'modifier/GET_MODIFIERS_FAIL'
export const RESET_MODIFIER_IDS = 'modifier/RESET_MODIFIER_IDS'

export type GetModifiersParams = {
  search_term?: string
  page?: number
  item_ids?: string[]
  option_ids?: string[]
}

export type GetModifiersResponse = {
  option_items: OptionItems[]
  pagination: {
    total_pages: number
    per_page: number
    current_page: number
    total_count: number
  }
}

export type GetModifiersOptions = {
  itemIds?: string[]
  optionIds?: string[]
  searchTerm?: string
  page?: number
  cancelToken?: CancelToken
  method?: 'get' | 'post'
}

export function getModifiers({
  itemIds,
  optionIds,
  searchTerm = '',
  page = 1,
  cancelToken,
  method = 'get',
}: GetModifiersOptions = {}): AxiosAction<
  typeof GET_MODIFIERS,
  GetModifiersResponse
> {
  const hasItemIds = itemIds && itemIds.length > 0
  const hasOptionIds = optionIds && optionIds.length > 0
  const requestParams: GetModifiersParams = {
    search_term: searchTerm,
    page: page,
    ...(hasItemIds && { item_ids: itemIds }),
    ...(hasOptionIds && { option_ids: optionIds }),
  }

  return {
    type: GET_MODIFIERS,
    payload: {
      client: 'default',
      request: {
        url: 'options',
        method,
        // POST sends the ids in the body so a by-id lookup with many ids isn't
        // capped by the GET URL length.
        ...(method === 'post'
          ? { data: requestParams }
          : { params: requestParams }),
        ...(cancelToken && { cancelToken }),
      },
    },
  }
}

export function resetModifierIds() {
  return {
    type: RESET_MODIFIER_IDS,
  }
}

export type ResolvedAction =
  | ResolvedAxiosAction<ReturnType<typeof getModifiers>>
  | ResolvedAxiosAction<typeof resetModifierIds>

export type GetModifiersAction = AxiosAction<
  typeof GET_MODIFIERS,
  {
    option_items: OptionItems[]
    pagination: PaginationT
  }
>
